import React, { Component } from 'react';
import { injectCustomPlansAndRemoveRegular } from 'helpers/plans';

class SetUpcomingPlan extends Component {
  componentDidMount() {
    const { fetchUpcomingPlan, fetchAllPlans, subId, isSimo } = this.props;
    if (subId && !isSimo) {
      fetchUpcomingPlan(subId);
    }
    const params = { subscription_id: subId, is_upcoming: true };
    fetchAllPlans(params);
  }

  componentDidUpdate(prevProps, prevState) {
    const { planName, changeField } = this.props;
    if (prevProps.planName && prevProps.planName !== planName) {
      changeField('plan', 'plan_price', '');
    }
  }

  render() {
    const {
      PlanForm,
      subId,
      sub,
      user,
      setUpcomingPlan,
      isSimo,
      plans,
      upcomingPlan = [],
      userCustomPlans,
      isReseller,
      isAdmin,
      isAtt,
      showSplittedForm,
      ...props
    } = this.props;

    if (!sub || !plans) {
      return <div>Loading...</div>;
    }

    let injectedPlans = [].concat(plans);
    const userHasCustomPlans = userCustomPlans && userCustomPlans.length;
    if (
      (isAtt &&
        userHasCustomPlans &&
        user &&
        user.acl_group_name === 'BUSINESS') ||
      (isReseller && userHasCustomPlans) ||
      (isAdmin && userHasCustomPlans)
    ) {
      injectedPlans = injectCustomPlansAndRemoveRegular({
        sub,
        plans: injectedPlans,
        customPlans: userCustomPlans,
      });
    }

    // att plan fix
    if (
      isAtt &&
      upcomingPlan &&
      upcomingPlan[0] &&
      !injectedPlans.find((plan) => plan.id === upcomingPlan[0].plan)
    ) {
      const oldPlan = plans.find((plan) => plan.id === upcomingPlan[0].plan);
      if (oldPlan) {
        injectedPlans.push({ ...oldPlan, hidePlan: true });
      }
    }

    let initialValues = {};
    if (isSimo) {
      initialValues = {
        plan_id: (sub && sub.upcoming_plan && sub.upcoming_plan.id) || null,
      };
    } else if (showSplittedForm && upcomingPlan[0]) {
      const plan = injectedPlans.find(
        (plan) => plan.id === upcomingPlan[0].plan,
      );
      initialValues = {
        plan_name: plan && plan.name,
        plan_price: plan && plan.price,
        plan_lock: upcomingPlan[0].plan_lock,
      };
    } else if (upcomingPlan[0]) {
      initialValues = {
        plan_id: upcomingPlan[0].plan,
        plan_lock: upcomingPlan[0].plan_lock,
      };
    }

    if (!PlanForm) {
      return null;
    }

    return (
      <PlanForm
        {...props}
        showLockCheckbox={!isSimo}
        initialValues={initialValues}
        onSubmit={(values) => setUpcomingPlan(subId, values)}
        subId={subId}
        plans={injectedPlans}
        isSimo={isSimo}
      />
    );
  }
}

export default SetUpcomingPlan;
